// import { createRegistry } from '../registry';
// import { Logger as LoggerInstance } from './logger';
// // Define the type for the logger provider.  Currently supporting 'pino'.
// type LoggerProvider = 'pino';
// const LOGGER = (process.env.LOGGER ?? 'pino') as LoggerProvider;
// // Create a registry for logger implementations
// const loggerRegistry = createRegistry<LoggerInstance, LoggerProvider>();
// // Register the 'pino' logger implementation
// loggerRegistry.register('pino', async () => {
//   const { Logger: PinoLogger } = await import('./impl/pino');
//   return PinoLogger;
// });
// /**
//  * @name getLogger
//  * @description Retrieves the logger implementation based on the LOGGER environment variable using the registry API.
//  */
// export async function getLogger() {
//   return loggerRegistry.get(LOGGER);
// }
import { ILogger, ILogger as LoggerInstance } from './logger';

const LOGGER = process.env.LOGGER ?? 'winston';

/*
 * Logger
 * By default, the logger is set to use Winston. To change the logger, update the import statement below.
 * to your desired logger implementation.
 */
async function getLogger(context?: string): Promise<LoggerInstance> {
  if (process.env.NEXT_RUNTIME === 'nodejs') {
    switch (LOGGER) {
      case 'winston': {
        const { Logger: WinstonLogger } = await import('./impl/winston');

        WinstonLogger.defaultMeta = { context: context ?? 'default' };

        return WinstonLogger;
      }

      default:
        throw new Error(`Unknown logger: ${process.env.LOGGER}`);
    }
  }

  return {
    info: (...args: unknown[]) => console.log(...args),
    error: (...args: unknown[]) => console.log(args),
    warn: (...args: unknown[]) => console.log(args),
    debug: (...args: unknown[]) => console.log(args),
  };
}

export { getLogger, type ILogger };
